import styled from 'styled-components';

import Heading from '../../components/Heading/Heading.styled';

export const PopupTitleStyled = styled(Heading)`
  ${({ theme }) => `
    color: ${theme.primaryColour};
  `}
`;

export const SubTitleStyled = styled(Heading)`
  margin-top: 30px;
  color: #000;
`;

export const NoteStyled = styled.p`
  font-style: italic;
  color: #000;

  ${({ theme }) => `
    font-size: ${theme.fontSizes.xSmall};
    font-weight: ${theme.fontWeights.medium};
  `}
`;

export const ControlsWrapperStyled = styled.div`
  margin-top: 40px;
  display: flex;
  gap: 10px;
`;
